export default __webpack_public_path__ + "static/media/gallery_02.5e0da810.jpg";